export enum EEndpoints {
    signIn,
    logOut,
    admins,
    adminsDel,
    adminsUnblock,
    users,
    usersDetail,
    usersDel,
    usersUnlock,
    usersLock,
    usersPinReset,
    usersSuspend,
    usersActivate,
    usersEKycGet,
    usersEKycSet,
    transactionsGet,
    transactionsWithdraw,
    transactionsPulsa,
    transactionsByType,
    complaintsGet,
    complaintAdd,
    complaintDel,
    complaintEdit,
    withdrawsGet,
    withdrawsAdd,
    pendingTasksGet,
    pendingTasksApprove,
    pendingTasksReject,
    generate2FA,
    confirm2FA,
    screeningsGet,
    screeningCreate,
    screeningDownload,
    adminPermissionRoles,
    adminsUpdate,
    revalidateCftByUserId,
    revalidateKtpByUserId,
    adminActivityLogs,
    adminActivityLogDetail,
    userActivityLogs,
    userActivityLogDetail,
}

const endpoints = {
    [EEndpoints.signIn]: () => 'auth/signin',
    [EEndpoints.logOut]: () => 'auth/logout',
    [EEndpoints.admins]: () => 'admins',
    [EEndpoints.adminsDel]: (id: string) => `admins/${id}`,
    [EEndpoints.adminsUnblock]: (id: string) => `admins/${id}/unblock`,
    [EEndpoints.adminPermissionRoles]: () => `admins/permissions`,
    [EEndpoints.adminsUpdate]: (id: string) => `admins/${id}`,
    [EEndpoints.users]: () => 'users',
    [EEndpoints.usersUnlock]: (id: string) => `users/${id}/unblock`,
    [EEndpoints.usersLock]: (id: string) => `users/${id}/block`,
    [EEndpoints.usersDel]: (id: string) => `users/${id}`,
    [EEndpoints.usersDetail]: (id: string) => `users/${id}`,
    [EEndpoints.usersSuspend]: (id: string) => `users/${id}/suspend`,
    [EEndpoints.usersActivate]: (id: string) => `users/${id}/activate`,
    [EEndpoints.usersPinReset]: (id: string) => `users/${id}/pin/reset`,
    [EEndpoints.usersEKycGet]: (id: string) => `users/${id}/ekyc`,
    [EEndpoints.usersEKycSet]: (id: string) => `users/${id}/ekyc`,
    [EEndpoints.revalidateCftByUserId]: (id: string) =>
        `users/${id}/validate/cft`,
    [EEndpoints.revalidateKtpByUserId]: (id: string) =>
        `users/${id}/validate/ktp`,
    [EEndpoints.transactionsGet]: () => `transactions`,
    [EEndpoints.transactionsWithdraw]: (id: string) =>
        `transactions/${id}/withdraw`,
    [EEndpoints.transactionsPulsa]: (id: string) => `transactions/${id}/pulsa`,
    [EEndpoints.transactionsByType]: (id: string, type: string) =>
        `transactions/${id}/${type}`,
    [EEndpoints.complaintsGet]: () => `complaints`,
    [EEndpoints.complaintAdd]: () => `complaints`,
    [EEndpoints.complaintDel]: (id: number) => `complaints/${id}`,
    [EEndpoints.complaintEdit]: (id: number) => `complaints/${id}`,
    [EEndpoints.withdrawsGet]: () => `transactions/cash-withdraws`,
    [EEndpoints.withdrawsAdd]: () => `transactions/cash-withdraws`,
    [EEndpoints.pendingTasksGet]: () => `pending-tasks`,
    [EEndpoints.pendingTasksApprove]: (id: string) =>
        `pending-tasks/${id}/approve`,
    [EEndpoints.pendingTasksReject]: (id: string) =>
        `pending-tasks/${id}/reject`,
    [EEndpoints.generate2FA]: () => `generate-2fa`,
    [EEndpoints.confirm2FA]: () => `confirm-2fa`,
    [EEndpoints.screeningsGet]: () => `admins/bulk-validate`,
    [EEndpoints.screeningCreate]: () => `admins/bulk-validate`,
    [EEndpoints.screeningDownload]: (id: string) =>
        `admins/bulk-validate/${id}/download`,
    [EEndpoints.adminActivityLogs]: () => `admins/logs`,
    [EEndpoints.adminActivityLogDetail]: (id: string) => `admins/logs/${id}`,
    [EEndpoints.userActivityLogs]: () => `users/logs`,
    [EEndpoints.userActivityLogDetail]: (id: string) => `users/logs/${id}`,
};

export default endpoints;
